export default __webpack_public_path__ + "fa2d0feb545e5ff379bd055166ab061e.svg";